<script lang="ts">
  let { auth, goTo } = $props();

  let credentials = $state({ login: "", passwd: "" });
  let loginFailed = $state(false);

  function handleSubmit(event: SubmitEvent): void {
    event.preventDefault();
    auth.login(credentials).then(
      () => goTo("main"),
      () => {
        loginFailed = true;
      },
    );
  }

  function clearError(): void {
    loginFailed = false;
  }
</script>

<div class="login-form">
<h2 class="text-center">Zaloguj się</h2>
<form class="form" novalidate onsubmit={handleSubmit}>
    <div class="form-group">
    <input type="text" class="form-control" placeholder="Nazwa użytkownika" id="username" bind:value={credentials.login} oninput={clearError}>
    </div>
    <div class="form-group">
    <input type="password" class="form-control" placeholder="Hasło" id="password" bind:value={credentials.passwd} oninput={clearError}>
    </div>
    <div class="form-group">
    <button type="submit" class="btn btn-primary btn-block">Zaloguj się</button>
    </div>
    {#if loginFailed}
    <div class="form-group" style="color:red; text-align: center">
        Nieprawidłowa nazwa użytkownika lub hasło!
    </div>
    {/if}
</form>
</div>
